/**
 * <summary>
 * formik form to upload or update Headquarter after and before medical templates.
 * store can choose from uploaded templates.
 * </summary>
 */
import { Form, Formik, Field } from "formik";
import { Col, Row } from "react-bootstrap";
import LoaderButton from "../../../shared-components/button/loader-button";
import {IUpdateHeadquarterCancelationPolicy } from "../../../models/response/IHeadquarterResponse";
import { FormattedMessage } from "react-intl";
import { cancelationPolicyValidateSchema, templateImageValidateSchema } from "../../../shared-components/FormikFormHandlers/FormikValidationSchema";
import FormikReactQuill from "../../../shared-components/FormikFormHandlers/FormikFormReactQuill";
import toast from "react-hot-toast";
import { format } from "path";
import { formatMessage } from "../../../translations/format-message";
import FormikFormTextArea from "../../../shared-components/FormikFormHandlers/FormikFormTextArea";
import Label from "../../../shared-components/label/label";
import FormikFormCheckBox from "../../../shared-components/FormikFormHandlers/FormikFormCheckBox";
import _ from "lodash";

interface IProps {
  id: number;
  submitHandler: (data: IUpdateHeadquarterCancelationPolicy) => void;
  loading: boolean;
  initialValues: any;
  isUpdateMode: boolean;
  disableAction: boolean;
}

const AddEditCancelationPolicyForm = (props: IProps) => {
  return (
    <Formik
      initialValues={props.initialValues}
      enableReinitialize
      validationSchema={cancelationPolicyValidateSchema}
      validateOnBlur={false}
      onSubmit={async (values, { resetForm }) => {
        if (values.HeadquarterCancelationText?.toLowerCase().includes("{time}".toLowerCase())) {
          props.submitHandler(values);
          resetForm();
        }
        else {
          toast.error(
            formatMessage("cancelation_policy_text_error")
          );
        }

      }}
    >
      {({ values }) => (
        <Form className="setting-form" noValidate>
          <Row className="position-relative">            
            <Col xs={12} md={12}>            
                <div className="form-group">
                    <Label
                      className="label-style"
                      required={true}
                      label="cancelation_policy_text"
                    />
                    <Field
                      type="text"
                      as={FormikFormTextArea}
                      row={5}
                      name="HeadquarterCancelationPolicy"
                      disabled={!props.isUpdateMode}
                    />
                    <p className="small text-muted text-end mt-1">{`${
                      values.HeadquarterCancelationPolicy ? values.HeadquarterCancelationPolicy.length : 0
                    }/500`}</p>
                </div>
            </Col>
            <Col xs={12} md={12}>
                <div className="form-group">
                    <Label
                      className="label-style"
                      required={true}
                      label="cancelation_text"
                    />
                    <Field
                      type="text"
                      as={FormikFormTextArea}
                      row={3}
                      name="HeadquarterCancelationText"
                      disabled={!props.isUpdateMode}
                    />
                    <div className="row">
                      <div className="col-9">
                        <small className="text-muted"><FormattedMessage id="cancelation_text_warning" /></small>
                      </div>
                      <div className="col-3 text-end">
                        <p className="small text-muted text-end mt-1">{`${
                          values.HeadquarterCancelationText ? values.HeadquarterCancelationText.length : 0
                          }/300`}</p>
                      </div>
                    </div>   
                </div>
            </Col>
            {/* <Col xs={12} md={12}>
              <div className="form-group">
                  <div className="form-check form-switch d-flex align-items-center">
                    <Field
                      className="form-check-input"
                      name="ShowOnFilter"
                      type="checkbox"
                      id="Showonfilter"
                      disabled={!props.isUpdateMode}
                    />
                    <label
                      htmlFor="Showonfilter"
                      className="form-check-label ms-2"
                    >
                      <FormattedMessage id="show_category_on_filter" />
                    </label>
                  </div>
              </div>
            </Col> */}
            <Col xs={12} md={12}>
              <LoaderButton
                type="submit"
                className="mt-3"
                isLoading={props.loading}
                disabled={_.isEqual(props.initialValues, values) || props.disableAction
                }
                text={
                  props.initialValues?.TemplateBeforeOne
                    ? "button_update"
                    : "button_save"
                }
              />
            </Col>
          </Row>
        </Form>
      )}
    </Formik>
  );
};

export default AddEditCancelationPolicyForm;
